import React from 'react';

import type { PaymentsCommon } from '../usecases/usecaseTypes';

// the types that will pass to all components
// distributed
interface NewPaymentsProviderContextValue extends PaymentsCommon {}

const PaymentsContext = React.createContext<
  NewPaymentsProviderContextValue | undefined
>(undefined);

export const usePayments = () => {
  const context = React.useContext(PaymentsContext);
  if (context === undefined) {
    throw new Error(
      'usePaymentsContext must be used within a PaymentsProvider',
    );
  }
  return context;
};

// the type that will be passed to payment provider
// to initialize
interface NewPaymentsProviderProps extends PaymentsCommon {
  children: React.ReactNode;
}

export const PaymentsProvider = (props: NewPaymentsProviderProps) => {
  const { children, ...contextValues } = props;

  return (
    <PaymentsContext.Provider value={{ ...contextValues }}>
      {children}
    </PaymentsContext.Provider>
  );
};
